import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'ap-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.css'],
    standalone: false
})
export class ImageViewerComponent {
  @Input() src: string = '';
  @Input() alt: string = '';
  @Input() extension: string = '';
  @ViewChild('img', { static: true }) imgRef!: ElementRef<HTMLImageElement>;
  @ViewChild('imageWrapper', { static: true }) wrapperRef!: ElementRef<HTMLDivElement>;

  zoom = 1;
  minZoom = 0.2;
  maxZoom = 5;

  translateX = 0;
  translateY = 0;
  isDragging = false;
  lastX = 0;
  lastY = 0;

  ngAfterViewInit(): void {
    const el = this.wrapperRef.nativeElement;
    el.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
  }

  onWheel(event: WheelEvent): void {
    event.preventDefault();

    const zoomFactor = 0.1;
    const direction = Math.sign(event.deltaY);
    const newZoom = this.zoom * (1 - direction * zoomFactor);
    this.zoom = Math.min(this.maxZoom, Math.max(this.minZoom, newZoom));
  }

  onMouseDown(event: MouseEvent): void {
    if (this.zoom <= 1) return;
    this.isDragging = true;
    this.lastX = event.clientX;
    this.lastY = event.clientY;
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.isDragging) return;

    const dx = event.clientX - this.lastX;
    const dy = event.clientY - this.lastY;
    this.lastX = event.clientX;
    this.lastY = event.clientY;

    this.translateX += dx;
    this.translateY += dy;
  }

  onMouseUp(): void {
    this.isDragging = false;
  }

  onMouseLeave(): void {
    this.isDragging = false;
  }

  downloadImage(): void {
    const a = document.createElement('a');
    a.href = this.src;
    a.download = this.alt + '.' + (this.extension || 'jpg');
    a.click();
  }

  resetZoom(): void {
    this.zoom = 1;
    this.translateX = 0;
    this.translateY = 0;
  }

}
